import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./App.css";
import "./index.css";
import Main from "./page/index";
import MainV2 from "./page/testeb";
import TesteC from "./page/testec";
import TesteD from "./page/tested";
import "./style/styled-global.scss";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/tim" replace />} />
          <Route path="/*" element={<Navigate to="/tim" replace />} />
          <Route exact path="/tim" element={<Main />} />
          <Route exact path="/tim/b" element={<MainV2 />} />
          <Route exact path="/tim/c" element={<TesteC />} />
          <Route exact path="/tim/d" element={<TesteD />} />
        </Routes>
        <ToastContainer />
      </Router>
    </div>
  );
}

export default App;
